import React from 'react'

import useStyles from './styles'

interface ArticleStatusProps {
  publishedAt: string | null
  archivedAt: string | null
  onClick: () => void
}

const ArticleStatus: React.FC<ArticleStatusProps> = ({
  publishedAt,
  archivedAt,
  onClick
}) => {
  const classes = useStyles()

  if (publishedAt) {
    return (
      <td onClick={onClick} className={classes.root} role='cell'>
        <div className={classes.published}>
          <svg
            width='8'
            height='8'
            viewBox='0 0 8 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='4' cy='4' r='4' fill='#5CC043' />
          </svg>
          Published
        </div>
      </td>
    )
  }

  if (archivedAt) {
    return (
      <td onClick={onClick} className={classes.root} role='cell'>
        <div className={classes.unpublished}>
          <svg
            width='8'
            height='8'
            viewBox='0 0 8 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='4' cy='4' r='4' fill='#8F8F8F' />
          </svg>
          Unpublished
        </div>
      </td>
    )
  }

  if (publishedAt === null) {
    return (
      <td onClick={onClick} className={classes.root} role='cell'>
        <div className={classes.draft}>
          <svg
            width='8'
            height='9'
            viewBox='0 0 8 9'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='4' cy='4.5' r='4' fill='#D5A428' />
          </svg>
          Draft
        </div>
      </td>
    )
  }

  return null
}

export default ArticleStatus
